import {
  pagesState
} from "./pages.state";
import {
  pagesActions
} from "./pages.actions";
import {
  pagesGetters
} from "./pages.getters";
import {
  pagesMutations
} from "./pages.mutations";

export default {
  state: pagesState,
  actions: pagesActions,
  getters: pagesGetters,
  mutations: pagesMutations
};